import {
  CLOSE_LOGIN_MODAL,
  CLOSE_REGISTER_MODAL,
  OPEN_LOGIN_MODAL,
  OPEN_VENDOR_REGISTER_MODAL,
  OPEN_VENUE_REGISTER_MODAL,
} from './constants';

export const openVenueRegisterModal = () => ({
  type: OPEN_VENUE_REGISTER_MODAL,
});

export const openVendorRegisterModal = () => ({
  type: OPEN_VENDOR_REGISTER_MODAL,
});

export const closeRegisterModal = () => ({
  type: CLOSE_REGISTER_MODAL,
});

export const openLoginModal = () => ({
  type: OPEN_LOGIN_MODAL,
});

export const closeLoginModal = () => ({
  type: CLOSE_LOGIN_MODAL,
});
